var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgB3WallHeating(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.58 46.25l6.49-7.83-6.49-7.82 6.3-7.6h5.24l-6.3 7.6 6.49 7.83-6.49 7.83L30.41 53h-5.24l-5.59-6.75zm16.2-7.83l-6.49 7.83L34.88 53h5.24l-5.59-6.75L41 38.43l-6.48-7.83 6.3-7.6h-5.24l-6.3 7.6 6.5 7.82zm9.7 0L39 46.25 44.58 53h5.24l-5.59-6.75 6.49-7.83-6.49-7.82 6.3-7.6h-5.25L39 30.6l6.48 7.82zm9.7 0l-6.49 7.83L54.28 53h5.24l-5.59-6.75 6.49-7.83-6.49-7.82 6.3-7.6H55l-6.3 7.6 6.48 7.82zM69 7v62H7V7h62zm-4 4H15v54h50V11z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/B3_Wall_heating.757ab006.svg";
export { SvgB3WallHeating as ReactComponent };